import { render, staticRenderFns } from "./ProfileDetail.vue?vue&type=template&id=34ec47ed&"
import script from "./ProfileDetail.vue?vue&type=script&lang=js&"
export * from "./ProfileDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDetail.vue?vue&type=style&index=0&id=34ec47ed&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports